import axios from '@service'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'
import { SAFETY_MFG_URL } from '@config'


// 考勤信息分页查询
export const getAttendanceInfoPage = async (payload = {}, config = {}) => {
    const { size, current, ...other } = payload
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-information/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: {
            size,
            current
        },
        data: other || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}


// 工资信息分页查询
export const getSalaryInfoPage = async (payload = {}, config = {}) => {
    const { size, current, ...other } = payload
    const param = {
        url: `${SAFETY_MFG_URL}/salary-information/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: {
            size,
            current
        },
        data: other || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}


// 银行流水信息分页查询
export const getBankFlowInfoPage = async (payload = {}, config = {}) => {
    const { size, current, ...other } = payload
    const param = {
        url: `${SAFETY_MFG_URL}/bank-flow-information/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: {
            size,
            current
        },
        data: other || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 考勤工资对账表分页查询(未确认)
export const getAttendanceSalaryReconciliationPage = async (payload = {}, config = {}) => {
    const { size, current, ...other } = payload
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-salary-reconciliation/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: {
            size,
            current
        },
        data: other || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 考勤工资对账表分页查询(已核准)
export const getAttendanceSalaryReconciliationRecordPage = async (payload = {}, config = {}) => {
    const { size, current, ...other } = payload
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-salary-reconciliation-record/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: {
            size,
            current
        },
        data: other || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 工资银行流水对账表分页查询(未确认)
export const getSalaryBankFlowReconciliationPage = async (payload = {}, config = {}) => {
    const { size, current, ...other } = payload
    const param = {
        url: `${SAFETY_MFG_URL}/salary-bank-flow-reconciliation/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: {
            size,
            current
        },
        data: other || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 工资银行流水对账表分页查询(已核准)
export const getSalaryBankFlowReconciliationRecordPage = async (payload = {}, config = {}) => {
    const { size, current, ...other } = payload
    const param = {
        url: `${SAFETY_MFG_URL}/salary-bank-flow-reconciliation-record/page`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: {
            size,
            current
        },
        data: other || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}


// 考勤月上传签字文件
export const saveAttendanceSignDocuments = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-month/inside/saveSignDocuments`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 工资月上传签字文件
export const saveSalarySignDocuments = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/salary-month/inside/saveSignDocuments`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 获取考勤月签字扫描件
export const getAttendanceDocumentsById = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-month/inside/getDocumentsById`,
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 获取工资月签字扫描件
export const getSalaryDocumentsById = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/salary-month/inside/getDocumentsById`,
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 查询考勤月表头信息
export const getAttendanceMonthInfoById = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-month/inside/getById`,
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 查询工资月表头信息
export const getSalaryMonthInfoById = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/salary-month/inside/getById`,
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 工资月银行流水总额
export const getBankFlowInformationTotalAmount = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/bank-flow-information/direct/queryTotalAmount`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}


// 直连页面-考勤工资对账请求发起核准(返回核准结果描述)
export const pushAttendanceSalaryReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-salary-reconciliation-request/direct/requestReconciliation`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}


// 直连页面-考勤工资取消核准
export const cancelAttendanceSalaryReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-salary-reconciliation-request/direct/cancelReconciliation`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 直连页面-考勤工资确认核准
export const confirmAttendanceSalaryReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-salary-reconciliation-request/direct/confirmReconciliation`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}


// 直连页面-考勤工资对账请求发起核准(返回核准结果描述)
export const pushSalaryBankFlowReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/salary-bank-flow-reconciliation-request/direct/requestReconciliation`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}


// 直连页面-工资银行流水取消核准
export const cancelSalaryBankFlowReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/salary-bank-flow-reconciliation-request/direct/cancelReconciliation`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// 直连页面-工资银行流水确认核准
export const confirmSalaryBankFlowReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/salary-bank-flow-reconciliation-request/direct/confirmReconciliation`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// RPC-考勤工资对账临时表添加原因说明
export const updateReasonAttendanceSalaryReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/attendance-salary-reconciliation/inside/updateReason`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// RPC-工资银行流水对账临时表添加原因说明
export const updateReasonSalaryBankFlowReconciliation = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/salary-bank-flow-reconciliation/inside/updateReason`,
        method: 'post',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        data: payload || {}
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}

// RPC-获取项目对账执行进度情况
export const getProjectRecProcess = async (payload = {}, config = {}) => {
    const param = {
        url: `${SAFETY_MFG_URL}/project/inside/getProjectRecProcess`,
        method: 'get',
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 30000,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
